import React from 'react';
export function TestimonialsSection() {
  const testimonials = [{
    initials: 'MG',
    name: 'Marcela G.',
    loc: '📍 Córdoba | Docente de Física Secundaria',
    quote: 'Compré el MegaPack un domingo a la noche. El lunes tenía todo el año de Física organizado. Nunca pensé que un material iba a ser tan completo. Los guiones de clase son exactamente lo que necesitaba: no tengo que pensar de cero para cada clase. Y las rúbricas me salvaron de las discusiones con alumnos y familias.'
  }, {
    initials: 'CR',
    name: 'Cecilia R.',
    loc: '📍 Mendoza | Docente de Física y Química',
    quote: 'Empecé con Física y a los 3 días compré el Pack Completo. Doy las dos materias y no podía trabajar con la mitad del sistema. El Banco de Explicaciones Claras me cambió las clases: ahora tengo analogías listas para cada tema difícil y los chicos entienden a la primera.'
  }, {
    initials: 'RM',
    name: 'Roberto M.',
    loc: '📍 Buenos Aires | Docente de Química',
    quote: 'El Laboratorio Imposible me salvó el año. Siempre llegaba a clases prácticas sin materiales. Con el MegaPack resolví una experiencia de presión en 20 minutos con vasos y agua. Mis colegas me preguntaron cómo lo había preparado tan bien.'
  }, {
    initials: 'FL',
    name: 'Fernando L.',
    loc: '📍 Tucumán | Docente de Física Secundaria',
    quote: 'Lo que más valoro es que está organizado POR AÑO. No tengo que adivinar qué le corresponde a cada nivel. Todo ya está pensado, ordenado y listo. Es como tener un colega experto que ya hizo todo el trabajo por mí.'
  }, {
    initials: 'LP',
    name: 'Laura P.',
    loc: '📍 Rosario | Docente de Química Secundaria',
    quote: 'Como profe de Química lo que más me cambió fueron los volúmenes 3 y 4. Mis alumnos de 3° y 4° año por fin enganchan con la clase porque el contenido conecta con problemas reales. Ya no me peleo con el celular: los tengo ocupados pensando.'
  }, {
    initials: 'VT',
    name: 'Valeria T.',
    loc: '📍 Santa Fe | Docente de Física y Química',
    quote: "No tenemos laboratorio equipado y pensé que el material no me iba a servir. Pero el Bono 'Laboratorio Imposible' resolvió todo. Mis clases funcionan con materiales cotidianos. No necesité gastar nada."
  }];
  return <section className="bg-brand-dark py-32 px-4 border-t border-brand-border" data-id="element-249">
      <div className="max-w-6xl mx-auto" data-id="element-250">
        <h2 className="text-4xl md:text-5xl font-heading font-bold text-center text-white mb-20 max-w-4xl mx-auto leading-tight" data-id="element-251">
          LO QUE DICEN LOS DOCENTES QUE YA TIENEN SU{' '}
          <span className="text-brand-accent" data-id="element-252">MEGAPACK:</span>
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-253">
          {testimonials.map((test, i) => <div key={i} className="bg-brand-card rounded-3xl p-10 border border-brand-border" data-id="element-254">
              <div className="flex items-center gap-5 mb-8" data-id="element-255">
                <div className="w-16 h-16 rounded-full bg-brand-accent/10 border border-brand-accent/20 flex items-center justify-center font-heading font-bold text-brand-accent text-2xl flex-shrink-0" aria-hidden="true" data-id="element-256">
                  {test.initials}
                </div>
                <div data-id="element-257">
                  <div className="text-brand-accent mb-2 text-sm" aria-label="5 estrellas" data-id="element-258">
                    ⭐⭐⭐⭐⭐
                  </div>
                  <p className="font-bold text-white text-xl mb-1" data-id="element-259">
                    {test.name}
                  </p>
                  <p className="text-sm text-white/70 font-medium" data-id="element-260">
                    {test.loc}
                  </p>
                </div>
              </div>
              <blockquote className="text-white/80 italic leading-relaxed text-lg" data-id="element-261">
                "{test.quote}"
              </blockquote>
            </div>)}
        </div>
      </div>
    </section>;
}